module.exports = __webpack_public_path__ + "img/ic-maya.fbb7bd38.png";